export default __webpack_public_path__ + "static/media/Whatsup.cd17d49dc80950c0157a1dd4f4065cc4.webp";